import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

type Props = {
  size?: string;
  color?: string;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: '16' },
    color: { default: 'gray' }
  },
  setup(__props: any) {

const props = __props as { size: string, color: string }



const classes = computed(() => ({
  [`w-${props.size} h-${props.size}`]: true,
  [`bg-${props.color}-500`]: true,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['bal-circle', _unref(classes)])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})